import { FontSizeName } from "client/Misc/fontTools";
import { DOMOutputSpec, Mark, MarkSpec } from "prosemirror-model";

export enum FontSizeKind {
	Default = 0,
	Predefined = 1,
	Custom = 2
}

export function isPredefinedFontSize(fontSize: string): fontSize is FontSizeName {
	return /^(((x{1,2}-)?small)|(medium)|((x{1,3}-)?large))$/.test(fontSize);
}

export type FontSizeMarkAttributes = {
	kind: FontSizeKind.Predefined;
	size: FontSizeName;
} | {
	kind: FontSizeKind.Custom;
	size: string;
};

export const fontSize: MarkSpec = {
	attrs: {
		kind: { default: FontSizeKind.Custom },
		size: {}
	},
	parseDOM: [
		{
			style: "font-size",
			getAttrs: (styleValue): FontSizeMarkAttributes | false => {
				if (typeof styleValue !== "string") {
					throw new Error("Expected style value at this point");
				}

				if (isPredefinedFontSize(styleValue)) {
					return {
						kind: FontSizeKind.Predefined,
						size: styleValue
					};
				} else {
					return {
						kind: FontSizeKind.Custom,
						size: styleValue
					};
				}
			}
		}
	],
	toDOM: (node: Mark): DOMOutputSpec => {
		const {
			size
		} = (node.attrs as FontSizeMarkAttributes);

		return [
			"span",
			{
				style: `font-size: ${size};`
			},
			0
		];
	}
};